exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".clever-form{margin:auto;padding:20px}.clever-form input[type=date],.clever-form input[type=number],.clever-form input[type=text],.clever-form select,.clever-form textarea{width:100%;box-sizing:border-box;background:hsla(0,0%,100%,.1);padding:5px;border-radius:5px;margin-bottom:14px;border-width:thin}.clever-form textarea{min-height:5em;font-weight:400}.clever-form input:focus-visible,.clever-form select:focus-visible{outline:0}.clever-form label{font-weight:700;display:block;margin-bottom:1em}.existing-teacher-display{margin-bottom:1em}.form-row{display:flex;justify-content:space-between}.row-column{width:45%}.form-row label{flex:1;margin-right:.5em}#welcome-email-container{display:flex;align-items:start}#welcome-email-container input[type=checkbox]{margin-left:.5em;margin-right:1em}.submit-btn-container{width:100%;text-align:center}.exclude-link{cursor:pointer;margin-top:.5em}.expand-teachers-link{cursor:pointer;margin-bottom:.5em}.btn-container{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/clever_provisioning_form.scss
// module id = 820
// module chunks = 0